import React from 'react';
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import {useTranslation} from "react-i18next";
import Container from "@material-ui/core/Container";
import Card from "@material-ui/core/Card";
import {Button, CardActions, CardContent, Link, Typography} from "@material-ui/core";
import {HelpOutline, InfoOutlined} from "@material-ui/icons";
import PublicTrackingSearch from './PublicTrackingSearch';
import PublicTrackingHelpDialog from './PublicTrackingHelpDialog';
import {DESKTOP_LOGIN_LINKS, DESKTOP_REGISTRATION_LINKS} from "../../constants/Links";
import {getDomain} from "../../api/BackendRestClient";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: "flex",
            flex: 1,
            justifyContent: "center"
        },
        list: {
            flex: 1,
            "& img": {
                height: 100
            },
            "& .MuiButtonBase-root": {justifyContent: "center"},
            "& .MuiListItemText-root": {
                flex: "none", padding: 10,
                textTransform: "uppercase",
                fontWeight: 500
            }
        },
        card: {
            marginTop: 10,
            "& .MuiCardContent-root": {
                display: "flex",
                flex: 1,
                alignItems: "center",
                "& .MuiSvgIcon-root": {
                    marginRight: 10
                }
            }
        },
    }),
);

const PublicTrackingInfoComponents = () => {
    const classes = useStyles();

    return (<div className={classes.root}>

            <Container maxWidth="md">

                <PublicTrackingSearch/>

                <PublicTrackingInfoCard/>
            </Container>
        </div>
    );
};


export const PublicTrackingInfoCard: React.FC<any> = () => {
    const {t} = useTranslation();
    const classes = useStyles();

    const [openHelper, setOpenHelper] = React.useState(false);

    return <>

        <Card className={classes.card}>
            <CardContent>
                <HelpOutline fontSize="large"/>
                <div>
                    <Typography variant="h6" component="p">
                        {t("public-tracking.info.help")}
                    </Typography>
                    <Typography variant="body2" component="p">
                        {t("public-tracking.info.help-desc")}
                    </Typography>
                </div>
            </CardContent>
            <CardActions>
                <Container maxWidth="xs">
                    <Button variant="contained" size="small"
                            onClick={() => setOpenHelper(true)}
                            fullWidth={true}>{t("public-tracking.button.help")}</Button>
                </Container>
            </CardActions>
        </Card>

        <Card className={classes.card}>
            <CardContent>
                <InfoOutlined fontSize="large"/>
                <div>
                    <Typography variant="h6" component="p">
                        {t("public-tracking.info.spot")}
                    </Typography>
                    <Typography variant="body2" component="p">
                        {t("public-tracking.info.spot-desc")}
                    </Typography>

                    <Typography variant="body2">
                        {t("public-tracking.info.view-desc-1")}
                        <Link href={DESKTOP_REGISTRATION_LINKS[getDomain()]}>
                            {t("public-tracking.info.view-desc-register")}
                        </Link>
                        {t("public-tracking.info.view-desc-or")}
                        <Link href={DESKTOP_LOGIN_LINKS[getDomain()]}>
                            {t("public-tracking.info.view-desc-login")}
                        </Link>
                        {t("public-tracking.info.view-desc-to-spot")}
                    </Typography>

                </div>
            </CardContent>
            <CardActions>
                <Container maxWidth="xs">
                    <Button href={DESKTOP_REGISTRATION_LINKS[getDomain()]} variant="contained" size="small"
                            fullWidth={true}>{t("public-tracking.button.register")}</Button>
                </Container>
            </CardActions>
        </Card>

        <PublicTrackingHelpDialog open={openHelper} setOpen={setOpenHelper}/>
    </>
};


export default PublicTrackingInfoComponents;